import React from "react";
import { Loader2 } from "lucide-react";
import JsonModal from "./JsonModal";

export default function LogsTable({ logs, loading, page, pageSize }) {
  const [openJson, setOpenJson] = React.useState(false);
  const [jsonData, setJsonData] = React.useState(null);

  const formatTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    d.setHours(d.getHours() + 7);
    return d.toLocaleTimeString("vi-VN", { hour12: false });
  };

  // Tính toán số bản ghi cần hiển thị trên trang hiện tại
  const currentLogs = logs.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-primary text-xs uppercase text-white">
            <tr>
              <th className="px-3 py-2 ">Time</th>
              <th className="px-3 py-2">IMEI</th>
              <th className="px-3 py-2">Lat</th>
              <th className="px-3 py-2">Lng</th>
              <th className="px-3 py-2">Speed</th>
              <th className="px-3 py-2">Altitude</th>
              <th className="px-3 py-2">Direction</th>
              <th className="px-3 py-2">Mileage</th>
              <th className="px-3 py-2">Sat</th>
              <th className="px-3 py-2"></th>
            </tr>
          </thead>

          <tbody>
            {!loading && logs.length === 0 && (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-4 text-gray-500 bg-gray-50"
                >
                  Không có dữ liệu.
                </td>
              </tr>
            )}

            {loading && (
              <tr>
                <td
                  colSpan={8}
                  className="py-6 text-center text-gray-500 bg-gray-50"
                >
                  <Loader2 size={20} className="animate-spin mx-auto" />
                </td>
              </tr>
            )}

            {!loading &&
              currentLogs.map((log, idx) => (
                <tr
                  key={`${log.imei}-${log.gpsdate_unix}-${idx}`}
                  className=" text-center border-t border-gray-100 hover:bg-primary/5"
                >
                  <td className="px-3 py-2">{formatTime(log.gps_datetime)}</td>
                  <td className="px-3 py-2 font-mono text-xs">{log.imei}</td>
                  <td className="px-3 py-2">{log.body?.latitude ?? "-"}</td>
                  <td className="px-3 py-2">{log.body?.longitude ?? "-"}</td>
                  <td className="px-3 py-2">{log.body?.speed_kmh ?? 0} km/h</td>
                  <td className="px-3 py-2">{log.body?.altitude ?? "-"}</td>
                  <td className="px-3 py-2">{log.body?.direction ?? "-"}</td>
                  <td className="px-3 py-2">{log.body?.mileage ?? "-"}</td>
                  <td className="px-3 py-2">{log.body?.gnss_satellites ?? "-"}</td>
                  <td className="px-3 py-2">
                    <button
                      className="px-3 py-1 bg-primary text-white rounded text-xs"
                      onClick={() => {
                        setJsonData(log.body);
                        setOpenJson(true);
                      }}
                    >
                      JSON
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <JsonModal
        open={openJson}
        onClose={() => setOpenJson(false)}
        data={jsonData}
      />
    </div>
  );
}
